import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { VehicleInsuranceCoverageTypeEnum } from '../enums/vehicle-insurance-coverage-type.enum';
import { VehicleInsurancePremiumPeriodEnum } from '../enums/vehicle-insurance-premium-period.enum';
import { VehicleInsuranceRecordCategoryEnum } from '../enums/vehicle-insurance-record-category.enum';
import { VehicleInsuranceStatusEnum } from '../enums/vehicle-insurance-status.enum';

/**
 * Create vehicle insurance DTO
 */
export class CreateVehicleInsuranceDto {
  color?: string | null;
  externalReference?: string | null;
  status!: VehicleInsuranceStatusEnum;
  notes?: string | null;
  recordCategory!: VehicleInsuranceRecordCategoryEnum;
  coverageType?: VehicleInsuranceCoverageTypeEnum | null;
  coverageDescription?: string | null;
  premiumPeriod!: VehicleInsurancePremiumPeriodEnum;
  @TransformDate()
  startsAt!: Date;
  @TransformDate()
  endsAt!: Date;
  @TransformInt()
  vehicleId!: number;
  @TransformInt()
  supplierId?: number | null;
  @TransformInt()
  policyNumber?: number | null;
  @TransformInt()
  coverNoteNumber?: number | null;
  @TransformFloat()
  insuredValue?: number | null;
  @TransformFloat()
  excessAmount?: number | null;
  @TransformFloat()
  totalLossPercentage?: number | null;
  @TransformFloat()
  computedTotalLossAmountReceivable?: number | null;
  taxRateType?: TaxRateTypeEnum | null;
  @TransformFloat()
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  @TransformFloat()
  amount?: number | null;
  @TransformFloat()
  totalNet?: number | null;
  @TransformFloat()
  totalTax?: number | null;
  @TransformFloat()
  totalGross?: number | null;
  tags?: TagDto[] | null;
  files?: FileDto[] | null;
}
